import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const persistedStatePlugin = ({ $pinia }) => {
  $pinia.use(piniaPluginPersistedstate)
}

export default persistedStatePlugin
